import { ButtonDesktop as Button } from '@tui-react/button';
import cn from 'classnames';
import React from 'react';
import Markdown from '../../../../components/Markdown';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { usePollStatePredicate } from '../../../../reducer/machine/utils';
import { inIframe } from '../../../../utils/location';
import styles from './Footer.module.css';

interface FooterCommonProps {
  className?: string;
  isLoading?: boolean;
  hint?: string;
  onAnswer: VoidFunction;
  answerButtonText: string;
  showAnswerButton: boolean;
  skipButtonText: string;
  alignSurvey: 'left' | 'center';
}

type FooterProps = FooterCommonProps | (FooterCommonProps & { canSkip: boolean; onSkip: VoidFunction });

export const Footer: React.FC<FooterProps> = ({
  className,
  answerButtonText,
  skipButtonText,
  isLoading,
  onAnswer,
  hint,
  alignSurvey,
  showAnswerButton,
  ...props
}) => {
  const instantlyAutoClosed = usePollStatePredicate('instantlyAutoClosed');
  const isPhone = useBreakpoint('phone');
  const buttonSize = isPhone ? 'l' : 'm';
  const showSkipButton = 'canSkip' in props && props.canSkip;
  const alignByCenter = alignSurvey === 'center';

  return (
    <footer
      className={cn(styles.footer, className, { [c(styles.iframe)]: inIframe(), [c(styles.center)]: alignByCenter })}
    >
      {showAnswerButton && (
        <div className={cn(styles.button, { [c(styles.fullwidthButton)]: !showSkipButton })}>
          <Button
            type="button"
            size={buttonSize}
            wide={isPhone}
            loading={isLoading}
            disabled={instantlyAutoClosed}
            {...(!isLoading && { onClick: onAnswer })}
          >
            {answerButtonText}
          </Button>
        </div>
      )}

      {showSkipButton && (
        <div
          className={cn(styles.button, {
            [c(styles.fullwidthButton)]: !showAnswerButton,
            [c(styles.skipButton)]: showAnswerButton,
          })}
        >
          <Button
            type="button"
            appearance="outline"
            size={buttonSize}
            wide={isPhone}
            onClick={props.onSkip}
            loading={isLoading}
            disabled={instantlyAutoClosed}
            {...(!isLoading && { onClick: props.onSkip })}
          >
            {skipButtonText}
          </Button>
        </div>
      )}

      {hint && <Markdown className={styles.hint}>{hint}</Markdown>}
    </footer>
  );
};
